module.exports = __webpack_public_path__ + "static/img/dangan_02.497050f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dangan_02.png
// module id = mWUe
// module chunks = 1